.list-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  margin: 5px;
  max-width: 100%;
}

.pagination-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.pagination-controls button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-controls span {
  align-self: center;
  font-size: 1.1em;
}

/* Media query for mobile devices */
@media (max-width: 768px) {
  .pagination-controls button {
    padding: 5px 5px;
  }
}

.carousel-box::-webkit-scrollbar {
  width: 5px;
  /* height: 2px; */
}
.carousel-box::-webkit-scrollbar-track {
  background: #f1f1f1; /* WebKit browsers */
}

.carousel-box::-webkit-scrollbar-thumb {
  background: #888; /* WebKit browsers */
  border-radius: 10px;
}
